export const tokenActionTypes = {
    CHANGE_USER_EMAIL: 'change_user_email',
    VERIFY_EMAIL: 'verify_email',
};
